import { gql } from 'graphql-request'
import { botApi } from '@client/client'

export const manualCoveringApi = botApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    manualCovering: builder.mutation<boolean, { botId: number }>({
      query: ({ botId }) => ({
        document: gql`
          mutation ManualCovering($botId: Int!, $botType: BotType!) {
            manualCovering(botId: $botId, botType: $botType)
          }
        `,
        variables: {
          botId: Number(botId),
          botType: 'Martingale',
        },
      }),
    }),
  }),
})

export const { useManualCoveringMutation } = manualCoveringApi
